import React from 'react'
import { Link, useLocation } from 'react-router-dom';

const PaymentCancelPage = () => {
    const location = useLocation();
    const message = location.state?.message || 'Your payment was not completed or was cancelled. Please try again using the payment button in your email.';

    return (
        <div className="thankYou_bx pad_t80 pad_b75">
            <div className='container'>
                <div className="d-flex justify-content-center">
                    <div className="card col-xl-5 col-lg-8 col-md-10 col-sm-10 bg-white shadow-lg p-5">
                        <div className="mb-4 text-center" style={{ color: 'red' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="75" height="75"
                                fill="currentColor" className="bi bi-x-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                            </svg>
                        </div>
                        <div className="text-center">
                            <h1>Payment Cancelled</h1>
                            <p className='mb-4 fs-6'>{message}</p>
                            {/* <Link to="/login" className="button2"> Try Again </Link> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentCancelPage
